/**
 * @generated SignedSource<<67ac23dd729c61d3a8bdd3f336062cfe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExpenseCategory = "CONSULTING_AND_ADMINISTRATION" | "HARDWARE_AND_EQUIPMENT" | "INFRASTRUCTURE" | "INSURANCE" | "MEMBERSHIPS_AND_DONATIONS" | "OTHER" | "SERVICES_AND_LICENSES" | "TRAVEL" | "VEHICLES" | "%future added value";
export type ServicePeriodStatus = "CONFIRMED" | "PROPOSED" | "%future added value";
export type ExpenseInvoiceFilter = {
  expenseCategory?: ExpenseCategory | null | undefined;
  includeDeleted?: boolean | null | undefined;
  searchTerm?: string | null | undefined;
  serviceMonth?: string | null | undefined;
  servicePeriodStatus?: ServicePeriodStatus | null | undefined;
  supplierIdentifier?: string | null | undefined;
  withoutExpenseCategory?: boolean | null | undefined;
  withoutServicePeriod?: boolean | null | undefined;
};
export type IncomingInvoicesViewQuery$variables = {
  filter?: ExpenseInvoiceFilter | null | undefined;
};
export type IncomingInvoicesViewQuery$data = {
  readonly suppliers: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly proposedServicePeriodCount: number;
    readonly supplierIdentifier: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"IncomingInvoicesView_invoices">;
};
export type IncomingInvoicesViewQuery = {
  response: IncomingInvoicesViewQuery$data;
  variables: IncomingInvoicesViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Supplier",
  "kind": "LinkedField",
  "name": "suppliers",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplierIdentifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "proposedServicePeriodCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v4 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IncomingInvoicesViewQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "IncomingInvoicesView_invoices"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IncomingInvoicesViewQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "ExpenseInvoiceConnection",
        "kind": "LinkedField",
        "name": "expenseInvoices",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ExpenseInvoiceEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ExpenseInvoice",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "supplierName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "invoiceNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "invoiceDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "servicePeriodStart",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "servicePeriodEnd",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "servicePeriodStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expenseCategory",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expenseCategoryOverride",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "netAmountInEuro",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "netAmountInServiceMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "netAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paidDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasDocument",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletedInFastBillAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "filters": [
          "filter"
        ],
        "handle": "connection",
        "key": "IncomingInvoicesView_expenseInvoices",
        "kind": "LinkedHandle",
        "name": "expenseInvoices"
      }
    ]
  },
  "params": {
    "cacheID": "76ec148ed210eb6a631956362ae0458d",
    "id": null,
    "metadata": {},
    "name": "IncomingInvoicesViewQuery",
    "operationKind": "query",
    "text": "query IncomingInvoicesViewQuery(\n  $filter: ExpenseInvoiceFilter\n) {\n  suppliers {\n    id\n    supplierIdentifier\n    name\n    proposedServicePeriodCount\n  }\n  ...IncomingInvoicesView_invoices_Vt7Yj\n}\n\nfragment IncomingInvoicesView_invoices_Vt7Yj on Query {\n  expenseInvoices(first: 100, filter: $filter) {\n    totalCount\n    edges {\n      node {\n        id\n        supplierName\n        invoiceNumber\n        invoiceDate\n        servicePeriodStart\n        servicePeriodEnd\n        servicePeriodStatus\n        expenseCategory\n        expenseCategoryOverride\n        netAmountInEuro\n        netAmountInServiceMonth\n        currency\n        netAmount\n        paidDate\n        hasDocument\n        deletedInFastBillAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0bcb90d708e5a6f70bf9bf9f37df2f0a";

export default node;
